


























































































































import { Component, Mixins } from 'vue-property-decorator';
import { appName, appEnv, gitCommitShortSHA, versionTag } from '@/env';
import { readUserProfile } from '@/store/main/getters';
import { dispatchUserLogOut } from '@/store/main/actions';
import NavBarMixin from '../mixins/NavBarMixin';

@Component
export default class NavBar extends Mixins(NavBarMixin) {
  public appName = appName;
  public appEnv = appEnv;
  public toggle = false;
  public gitCommitShortSHA = gitCommitShortSHA;
  public versionTag = versionTag;

  public toggleMenu() {
    this.toggle = !this.toggle;
  }
  public goToHome() {
    const route = { name: 'home' };
    this.$router.push(route);
  }

  public get appTitle() {
    if (appEnv === 'staging') {
      return appName + ' - STAGING';
    } else {
      return appName;
    }
  }

  public get nestedNavItems() {
    return this.navItems.filter(n => n.menuItems);
  }

  public get userDisplayName() {
    const profile = readUserProfile(this.$store);
    return profile ? profile.full_name : '';
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

  public toggleDarkMode() {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString());
  }

  public setTheme() {
    const theme = localStorage.getItem('dark_theme');
    if (theme) {
      if (theme === 'true') {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    } else if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      this.$vuetify.theme.dark = true;
      localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString());
    }
  }

  public mounted() {
    // Hack to set primary color because vue-meta resets theme
    setTimeout(() => this.setTheme(), 20);
  }
}
